<template>
  <div class="project-list">
    <el-row>
      <el-col :span="24">
        <div
          class="grid-content bg-white control-box"
          style="padding: 20px 20px 10px 20px"
        >
          <div class="left">
            <div class="select-box">
              <el-input
                v-model="search.customerName"
                :placeholder="$lange == 'en' ? 'Customer Name' : '客户名称'"
                size="mini"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="select-box">
              <el-input
                v-model="search.jobId"
                :placeholder="$lange == 'en' ? 'JOBID' : 'JOBID'"
                size="mini"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="select-box">
              <el-input
                size="mini"
                style="width: 200px"
                v-model="search.fasId"
                :placeholder="$lange == 'en' ? 'Project No.' : '编号'"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="select-box">
              <el-button type="primary" size="mini" @click="doSearch">{{
                $lange == "en" ? "Search" : "搜索"
              }}</el-button>
            </div>
            <div class="select-box">
              <el-button
                type="primary"
                size="mini"
                @click="goPage('/admin/project/create')"
                >{{ $lange == "en" ? "Create Project" : "创建项目" }}</el-button
              >
            </div>
            <div class="select-box">
              <el-button type="primary" size="mini" @click="exportFile">{{
                $lange == "en" ? "Create Project" : "导出搜索内容"
              }}</el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <cc-table :config="tableConfig" :params="search2"></cc-table>
  </div>
</template>

<script>
// import defaultIcon from "../../assets/default.png"
// import warningIcon from "../../assets/warning.png"
// import primaryIcon from "../../assets/primary.png"
// import dangerIcon from "../../assets/danger.png"
export default {
  name: "ProjectList",
  data() {
    return {
      search: {
        jobId: "",
        status: "",
        productLine: "",
        fasId: "",
        type: 0,
      },
      search2: {
        jobId: "",
        status: "",
        productLine: "",
        fasId: "",
        type: 0,
      },
      value: "",
      tableConfig: {
        api: "admin/fsb/project/query",
        showPager: true,
        pageSize: 10,
        columns: [
          {
            prop: "jobId",
            lable: "JOBID",
          },
          {
            lable: this.$lange == "en" ? "Customer Name" : "客户名称",
            render: (row) => {
              let res = "---";
              if (row.product && row.product.customer) {
                res = row.product.customer.customerName;
              }
              return res;
            },
             minWidth: 160,

          },
          {
            prop: "fasId",
            lable: this.$lange == "en" ? "Project No." : "编号",
          },
          {
            prop: "managerName",
            lable: this.$lange == "en" ? "Project Manager" : "项目经理",
             minWidth: 100,

          },
          {
            prop: "product.productLine",
            lable: this.$lange == "en" ? "Product Line" : "产品线",
          },
          {
            prop: "product.speed",
            lable: this.$lange == "en" ? "Speed" : "速度",
             minWidth: 100,
          },
          {
            prop: "product.breadth",
            lable: this.$lange == "en" ? "Width" : "幅宽",
          },
          {
            prop: "product.stackedLayers",
            lable: this.$lange == "en" ? "Stacked Layers" : "堆叠层数",
          },
          {
            prop: "product.corrugatedLayers",
            lable: this.$lange == "en" ? "Corrugated Layers" : "瓦楞层数",
          },
          {
            prop: "projectTime",
            lable: this.$lange == "en" ? "Project Time" : "项目时间",
             minWidth: 170,
          },
          {
            prop: "status",
            lable: this.$lange == "en" ? "Status" : "状态",
            type: "tag",
            options: [
              { tagType: "info", text: "Preparing" },
              { tagType: "success", text: "Installation" },
              { tagType: "warning", text: "Commissioning" },
              { tagType: "danger", text: "Acceptance" },
            ],
             minWidth: 125,
          },
          {
            prop: "createTime",
            lable: this.$lange == "en" ? "Create Time" : "创建时间",
             minWidth: 160,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "View Detail" : "查看",
            click: (row) => {
              this.$router.push({
                path: "/admin/project/description",
                query: {
                  fasId: row.fasId,
                },
              });
            },
          },
          {
            name: "",
            click: (row) => {},
          },
        ],
      },
    };
  },
  methods: {
    exportFile() {
      let text = "?appId=fosber&isAsc=false";
      for (const key in this.search2) {
        text += "&" + key + "=" + this.search2[key];
      }
      window.open(
        "/admin/fsb/project/exportProject" + text
      );
    },
    doSearch() {
      this.search2 = { ...this.search };
    },
    goPage(path) {
      let query = {};

      this.$router.push({
        path: path,
        query: query,
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.project-list {
  height: 100%;
  display: flex;
  flex-direction: column;

  .control-box {
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    .select-box {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 20px;
    }
  }
}
</style>
